import { Schema } from '@core/data/dto/schema';

export const DeliveryOrderDriverSchema = {
    id: Schema.String,
    location_id: Schema.String,
    company_id: Schema.String,
    latitude: Schema.Number,
    longitude: Schema.Number,
    name: Schema.String,
    status: Schema.Auto,
    avatar_url: Schema.String,
    polyline: Schema.String,
};
